import { useMemo } from 'react'
import { UseMatchingValues } from '@user/features/GlobalSearch/ResultItem/typings'

export const useMatchingValues = (props: UseMatchingValues) => {
  const { searchText, email } = props

  return useMemo(() => {
    return String(email).includes(searchText)
  }, [searchText, email])
}
